<template>
  <quota-menu-button read-only aid="over-quota-state-button">
    <template #editable-text
      >{{ overQuotaText }}
      <q-tooltip max-width="287px">
        Over-quota resources can be used. This can be modified via the Scheduling preferences
      </q-tooltip>
    </template>
  </quota-menu-button>
</template>

<script lang="ts">
import { defineComponent, inject, type PropType, ref } from "vue";

import { QuotaMenuButton } from "@/components/org-unit/quota-management/quota-inputs/quota-menu-button";
import type { EQuotaEntity } from "@/models/resource.model";
import { EOverQuotaLabel } from "@/models/resource.model";
import type { Resources } from "@/swagger-models/org-unit-service-client";
import {
  useQuotaInput,
  type useQuotaInputProperties,
} from "@/components/org-unit/quota-management/quota-inputs/quota-input-composable/use-quota-input.composeable";
import { orgUnitUtil } from "@/utils/org-unit.util";
export default defineComponent({
  name: "over-quota-button",
  components: { QuotaMenuButton },
  inject: ["entity"],
  props: {
    resource: {
      type: Object as PropType<Resources>,
      required: true,
    },
  },
  setup() {
    const entity = ref(inject<EQuotaEntity>("entity"));
    if (!entity.value) {
      throw new Error("'entity' is not provided");
    }

    const { isOverQuotaPriorityEnabled }: useQuotaInputProperties = useQuotaInput(entity.value);

    return {
      isOverQuotaPriorityEnabled,
    };
  },
  computed: {
    isOverQuotaEnabled(): boolean {
      return orgUnitUtil.isResourceOverQuotaEnabled(this.resource, this.isOverQuotaPriorityEnabled);
    },
    overQuotaText(): string {
      if (this.isOverQuotaEnabled) {
        return EOverQuotaLabel.Enabled;
      }
      return EOverQuotaLabel.Disabled;
    },
  },
});
</script>

<style scoped lang="scss"></style>
